import {ComponentNext, Link, makeChain, valueHelper as value}   from "@Common/react/cst2";
import {Types}                                                  from "@Common/types";

import {Selection, VariationSelectionState} from "./variations-state";

export const VariationsThumbnailsState = ({
    next: rootNext,
    templateBack,
    variationSelectionState: {
        enabled: variationsEnabled,
        selection,
        service: selectionService,
        setSelection,
    }
}:{
    next: Link<JSX.Element, null | {
        activeItemIndex: number,
        items: Array<{url: string, onSelect: () => void, outOfStock: boolean}>,
    }>,
    templateBack: Types.Apis.Payloads.Next.TemplateBack.GetTemplates.Response,
    variationSelectionState: ComponentNext<typeof VariationSelectionState>,
}) => !variationsEnabled ? rootNext(null) : (
    makeChain<JSX.Element>()
    .then("thumbnailsVariations", value(() => (
        templateBack.variations
        .reduce<Array<{url: string, selection: Selection}>>((thumbnailsVariations, variation) =>
        {
            const variationThumbnailUrl = variation.thumbnail[0]?.url;
            const variationSelection    = selectionService.makeFromVariation(variation);
            const item                  = thumbnailsVariations.find(({url}) => url === variationThumbnailUrl);
            if (item) {
                return [
                    ...thumbnailsVariations.slice(0, thumbnailsVariations.indexOf(item)),
                    {...item, selection: selectionService.intersect(item.selection, variationSelection)},
                    ...thumbnailsVariations.slice(thumbnailsVariations.indexOf(item) + 1),
                ];
            }
            else {
                return [...thumbnailsVariations, {url: variationThumbnailUrl, selection: variationSelection}];
            }
        }, [])
    )))
    .then(({thumbnailsVariations}) => rootNext({
        activeItemIndex: (
            thumbnailsVariations.findIndex(({url}) => url === selection.matchingVariations[0]?.thumbnail[0].url)
            ?? 0
        ),
        items: thumbnailsVariations.map(({url, selection: thumbnailSelection}) => ({
            url,
            onSelect: () => setSelection(selectionService.merge(selection.value, {
                target: thumbnailSelection,
                ifOutOfStock: "pivot",
            })),
            outOfStock: selectionService.isOutOfStock(selectionService.merge(selection.value, {
                target: thumbnailSelection,
                ifOutOfStock: "ignore",
            })),
        })),
    }))
    .run()
);

